import {Routes} from '@angular/router';

import {FILE_ROUTES} from './files/file.routes';
import {CONFIG_ROUTES} from './config/config.routes';
import {REPORTING_ROUTES} from './reporting/reporting.routes';
import {USER_ROUTES} from './user/user.routes';

export const APP_ROUTES: Routes = FILE_ROUTES.concat(
    CONFIG_ROUTES,
    REPORTING_ROUTES,
    USER_ROUTES
);



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/app.routes.ts